import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import dynamic from 'next/dynamic';

import { ICurrentCity } from '@r1-frontend/entities/City/models/ICurrentCity';

import AddressCard from '~/src/components/AddressCard';
import CheckAddressMapConnect from '~/src/components/CheckAddressMapConnect';
import { addressCardProps } from '~/src/constants/addressCard';
import { domainProps } from '~/src/constants/addressList';
import { ITariff } from '~/src/entities/formattedTariff';
import { getDistrictDeclination } from '~/src/helpers/getDistrictDeclination';
import { selectIsAuth } from '~/src/store/selectors/auth/selectIsAuth';

import * as ST from './styled';

const TariffLine = dynamic(() => import('~/src/components/TariffLine'));

type DistrictLayoutProps = {
    currentCity: ICurrentCity,
    district: domainProps,
    cards: addressCardProps[],
    tariffs: Array<ITariff>,
};

const DistrictLayout: React.FC<DistrictLayoutProps> = ({
    currentCity,
    district,
    tariffs,
    cards,
}) => {
    const [isMobileSlider, setisMobileSlider] = useState(false);
    const isAuth = useSelector(selectIsAuth);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            if (window.innerWidth >= 535 && window.innerWidth <= 760) {
                setisMobileSlider(true);
            } else {
                setisMobileSlider(false);
            }
          }
    }, []);

    const { name } = district;
    const header = `Провайдер интернета и ТВ в ${getDistrictDeclination(name, 'prepositional_case')}`;
    const nameIn = getDistrictDeclination(name, 'genitive_case');

    return (
        <ST.DistrictLayout>
            <ST.InnerContainer>
                <ST.FormTitle>{header}</ST.FormTitle>
                <ST.CheckDistrictBlock>
                    <CheckAddressMapConnect/>
                    <ST.DistrictDescription data-test='districtDescription'>
                        <ST.DistrictDiscTitle>
                            {`Улицы и дома ${nameIn}`}
                        </ST.DistrictDiscTitle>
                        <ST.DistrictText>
                            {`Слева, используя возможности нашего сервиса, Вы можете проверить адрес на возможность подключения 
                            услуг провайдера Дом.ру в вашем доме ${nameIn}. Чтобы узнать, подключен ли дом к интернету, нужно:`}
                            <ST.DistrictDescList>
                                <ST.DistrictDescItem>
                                    {`Заполнить онлайн форму, ввести название улицы в ${currentCity.cityIn} и номер дома;`}
                                </ST.DistrictDescItem>
                                <ST.DistrictDescItem>
                                    Нажать на кнопку «Проверить адрес» и осуществить проверку.
                                </ST.DistrictDescItem>
                            </ST.DistrictDescList>
                        </ST.DistrictText>
                    </ST.DistrictDescription>
                </ST.CheckDistrictBlock>
                <ST.TariffTitle>Наши тарифы</ST.TariffTitle>
                <TariffLine
                    isAuth={isAuth}
                    baseTariffs={tariffs}
                />
                <ST.FormSubTitle>Выбирая интернет Дом.ру, вы получаете:</ST.FormSubTitle>
                {isMobileSlider
                    ? (
                    <ST.CustomSwiperСardBlock
                        withoutDots
                        withoutArrows={true}
                        framePadding={'0 0 8px'}
                        slideWidth={'432px'}
                        cellSpacing={16}
                        slidesToScroll={'auto'}
                    >
                        {cards.map(item => {
                            return <AddressCard key={item.description} image={item.image} description={item.description} />;
                        })}
                    </ST.CustomSwiperСardBlock>)
                : (
                    <ST.AddressCardBlock>
                        {cards.map(item => {
                            return <AddressCard key={item.description} image={item.image} description={item.description} />;
                        })}
                    </ST.AddressCardBlock>)}
            </ST.InnerContainer>
        </ST.DistrictLayout>
    );
};

export default DistrictLayout;
